import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedGraphApp from "./EmbeddedGraphApp";
const GraphApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("microsoftgraph.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("microsoftgraph.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedGraphApp, null));
};
export default GraphApp;
